import {connect} from '@modifi/redux'
import {aPush, generatePath} from '@modifi/router'
import {compose} from 'ramda'
import {FeInputFieldStatus} from '@modifi/enums'

import {selectBeneficialOwnersAreLoading} from '../../../../data/beneficial-owners'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import BeneficialOwnerSummaryPage, {
  BeneficialOwnerSummaryPageProps,
} from './BeneficialOwnerSummaryPage'
import {SECTION_ULTIMATE_BENEFICIAL_OWNERS} from '../../../../constants/sections'
import {selectCompanyIsLocked} from '../../../../data/company'
import {selectUBOSummaryData} from './selector'
import {ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_CREATE} from '../../../../routes/constants'
import {
  aEnsureFetchResolvedPublicRegisteredCompanyDetails,
  aEnsurePublicRegisteredCompanies,
  selectHasUltimateBeneficialOwners,
  selectPublicRegisteredCompaniesRetrievalStatus,
  selectResolvedPublicRegisteredCompanyDetailsAreLoading,
} from '../../../../data/public-registered-companies'

const mapStateToProps = (
  state: Record<string, any>
): Pick<
  BeneficialOwnerSummaryPageProps,
  | 'isLoading'
  | 'uboSummary'
  | 'isReadonly'
  | 'pageIsVerified'
  | 'hasUbosFromProvider'
  | 'retrievalStatus'
> => {
  const companyIsLocked = selectCompanyIsLocked(state)
  const isVerified =
    selectCombinedInputFieldStatusBySectionName(state, SECTION_ULTIMATE_BENEFICIAL_OWNERS) ===
    FeInputFieldStatus.VERIFIED
  return {
    isLoading:
      selectBeneficialOwnersAreLoading(state) ||
      selectResolvedPublicRegisteredCompanyDetailsAreLoading(state),
    // @ts-expect-error to be fixed
    uboSummary: selectUBOSummaryData(state),
    isReadonly: isVerified || companyIsLocked,
    pageIsVerified: isVerified,
    hasUbosFromProvider: selectHasUltimateBeneficialOwners(state),
    retrievalStatus: selectPublicRegisteredCompaniesRetrievalStatus(state),
  }
}

const mapDispatchToProps = {
  createUbo: (): any => aPush(generatePath(ROUTE_COMPANY_PROFILE_BENEFICIAL_OWNERS_CREATE, {})),
  fetchResolvedCompanyDetails: aEnsureFetchResolvedPublicRegisteredCompanyDetails,
  fetchPublicRegisteredCompanies: aEnsurePublicRegisteredCompanies,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(BeneficialOwnerSummaryPage)
